// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3JM1d","selects":"Documents_selects__3Sf0h"};